import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllPrintOccurrenceReport from "./components/ListAllAuditPrintOccurrence";

export default function AuditPrintOccurrenceTable() {
    const { translate } = useLang();
    
    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Print occurrence')}`} />
            <ListAllPrintOccurrenceReport />
        </>
    )
}